import { SearchTrainInput, TransportOutput } from '@allocab/allocab-commons-shared-types';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

const fetchTrain = (input: SearchTrainInput) =>
  passengerApi.get<SearchTrainInput, TransportOutput>('/transport/v1/train', input);

const useFetchTrain = (options: UseMutationOptions<TransportOutput, APIError, SearchTrainInput> = {}) => {
  const fetchTrainMutation = useMutation<TransportOutput, APIError, SearchTrainInput>({
    mutationFn: fetchTrain,
    ...options,
  });

  return fetchTrainMutation;
};

export default useFetchTrain;
